export default "__VITE_ASSET__fab53116__"